import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./cardCarousel.css";

const CardCarousel = ({posts, socialMedia}) => {
    const cardStyle = {
        width: '400px', 
        height: socialMedia === 'Linkedin' ? '320px' : '150px'
    }

    const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

    return (
        // <div id={`carouselExampleCaptions${socialMedia}`} className="carousel slide" data-bs-ride="carousel">/
        <div className="container mt-5">
            <Slider {...settings}>
            {/* <div className="carousel-inner mt-5"> */}
                {
                    posts.map((post, idx) =>
                        <div className="carousel-item active">
                            <div className='d-flex justify-content-center align-items-center'>
                                <div className={`card border-0 shadow ${socialMedia === 'Linkedin' ? 'bg-primary-subtle bg-gradient' : 'bg-black'}`} style={cardStyle}>
                                    {socialMedia === 'Linkedin' && <a href={post.url} target='_blank' rel="noopener noreferrer"><img src={post.image} alt="..." className="card-img-top" style={{ height: '200px'}}/></a>}
                                    <div className="card-body">
                                        <p className={`card-text fs-5 fw-normal ${socialMedia === 'Linkedin' ? 'text-dark' : 'text-light'}`}>{post.text}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                </Slider>
            {/* </div> */}
            {/* <button className="carousel-control-prev" type="button" data-bs-target={`#carouselExampleCaptions${socialMedia}`} data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true" style={{ backgroundColor: 'black' }}></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target={`#carouselExampleCaptions${socialMedia}`} data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true" style={{ backgroundColor: 'black' }}></span>
                <span className="visually-hidden">Next</span>
            </button> */}
        </div>
    )
}

export default CardCarousel